import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import DropDown from '@/components/profile/dropDown'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/idVerification/constants"
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';

import '@/pages/profile/sections/common.css'

export default function UgDegreeList(props: any) {
    const { profile } = useLocalTranslation();
    const [formattedUgDegreeList, setFormattedUgDegreeList] = useState([])
    const ugDegreeList = useSelector((state: RootState) => state.ugDegreeListReducer.ugDegreeList);

    useEffect(() => {
        formatUgDegreeList()
    }, [ugDegreeList])

    function formatUgDegreeList() {
        const formattedUgDegreeList_ =  ugDegreeList.map((item: { title: any; }) => ({
            value: item.title,
            label: item.title
        }));
        setFormattedUgDegreeList(formattedUgDegreeList_)
    }


    return (
        <div className='profileSectionOfSectionCommonMainCon'>

            <p className='commonH2'>
                {profile.fields.selectUndergraduateDegree}
                <span className='text-[#FF2828]'>*</span>
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            <DropDown
                options={formattedUgDegreeList}
                value={props.value}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.underGraduateDegree)}
                placeholder={profile.placeHolders.qualification}
                customDropDownIcon={true}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.underGraduateDegree)}
                />
            </div>
        </div>
    );
}
